export default {
  operation: 'list',
}
